import { render, staticRenderFns } from "./LookUp.vue?vue&type=template&id=8a5eb9b6&scoped=true&"
import script from "./LookUp.vue?vue&type=script&lang=js&"
export * from "./LookUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5eb9b6",
  null
  
)

export default component.exports